import { matchRoutes, useLocation, useOutletContext } from 'react-router-dom';
import { connect } from 'react-redux';
import get from 'lodash/get';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import { palette } from '../theme/palette';
// import { routePaths } from '../utils/route-paths';
import { ReactComponent as PlusCircleIcon } from '../assets/icons/main/plus-circle-icon.svg';
import { useTheme } from '@mui/material';

interface AddButtonWithAccessCheckPropTypes {
  from: 'MasterComponent' | 'CardWithLabel' | 'OntologyManagement' | 'UserManagement';
  userAccess: any;
  onClick: () => void;
  styles?: object;
  otherProps?: any;
  label?:any;
  addNewLabel?: string;
}

const CardWithLabelStyles = {
  cardWithLabel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: '130px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  plusIcon: {
    width: '50px',
    height: '50px',
  },
  addLevelText: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: '22px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: palette.disabled.dark,
    textTransform: 'uppercase',
  },
};

const ontologyManagementStyles = {
  tooltipTitle: { fontSize: '1rem' },
  //   tooltipComponentProps: {
  //     tooltip: {
  //       sx: {
  //         padding: '4px 16px',
  //         display: 'flex',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //       },
  //     },
  //   },
};

const Styles = {
  disabledPlusIcon: {
    opacity: 0.6,
  }
};

const AddButtonWithAccessCheck = ({
  from,
  label,
  userAccess,
  onClick,
  styles = {},
  otherProps = {},
  addNewLabel,
}: AddButtonWithAccessCheckPropTypes) => {
  const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', [])
  const { pathname } = useLocation();
  const matchedRoute = matchRoutes(routePaths, pathname);
  const hasNoAccessToCreate = !get(userAccess, `${get(matchedRoute, '[0].route.endPointPath', '')}.create`, false);
  const theme: any = useTheme();

  if (from === 'CardWithLabel') {
    return (
      <Box sx={CardWithLabelStyles.cardWithLabel}>
        <Box sx={CardWithLabelStyles.wrapper}>
          <IconButton onClick={onClick} disabled={hasNoAccessToCreate}>
            <PlusCircleIcon style={{ ...CardWithLabelStyles.plusIcon, opacity: hasNoAccessToCreate ? 0.5 : 1, color: theme.palette.custom.light }} />
          </IconButton>
          <Typography sx={{ ...CardWithLabelStyles.addLevelText, opacity: hasNoAccessToCreate ? 0.5 : 1, color: theme.palette.text.primary }}>
            {otherProps.levelName || 'Add Level'}
          </Typography>
        </Box>
      </Box>
    );
  }
  if (from === 'OntologyManagement') {
    return (
      <Tooltip
        title={
          <Typography variant='subtitle1' sx={ontologyManagementStyles.tooltipTitle}>
            Add New {otherProps.levelName}
          </Typography>
        }
        placement='top'
        arrow
      >
        <IconButton onClick={onClick} disabled={hasNoAccessToCreate} style={{ padding: 0 }}>
          <PlusCircleIcon style={{ opacity: hasNoAccessToCreate ? 0.5 : 1, color: theme.palette.custom.light }} />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Button variant='contained' onClick={onClick} sx={{...styles}} disabled={hasNoAccessToCreate}>
      <PlusCircleIcon  /> 
     {addNewLabel ?? 'Add New' }
     
    </Button>
  );
};

const mapStateToProps = (state: any) => ({
  userAccess: state.profile.userAccess,
});

export default connect(mapStateToProps)(AddButtonWithAccessCheck);
